<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <h1>{{ `${cafeteria.name}` }}</h1>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.NAME") }}</dt>
          <dd class="col-sm-8">
            {{ cafeteria.name }}
          </dd>
        </dl>
        <dl class="row" v-if="cafeteria.service_type">
          <dt class="col-sm-4">{{ $t("CAFETERIAS.SERVICE_TYPE") }}</dt>
          <dd class="col-sm-8" v-if="cafeteria">
            {{ $t("CAFETERIAS.SERVICE_TYPE_" + cafeteria.service_type) }}
          </dd>
        </dl>
        <dl class="row" v-if="cafeteria.operation_type">
          <dt class="col-sm-4">{{ $t("CAFETERIAS.OPERATION_TYPE") }}</dt>
          <dd class="col-sm-8">
            {{ $t("CAFETERIAS.OPERATION_TYPE_" + cafeteria.operation_type) }}
          </dd>
        </dl>

        <dl
          class="row"
          v-if="
            cafeteria.operation_type === 'PRODUCTION' &&
            (cafeteria.internal_order_discounts || []).length
          "
        >
          <dt class="col-sm-4">
            {{ $t("CAFETERIAS.INTERNAL_ORDER_DISCOUNT") }}
          </dt>
          <dd class="col-sm-8">
            {{ cafeteria.internal_order_discounts[0].name }} :
            {{
              cafeteria.internal_order_discounts[0].type === "PERCENTAGE"
                ? `${cafeteria.internal_order_discounts[0].value} %`
                : $formatCurrency(cafeteria.internal_order_discounts[0].value)
            }}
          </dd>
        </dl>

        <dl class="row" v-if="cafeteria.order_type">
          <dt class="col-sm-4">{{ $t("CAFETERIAS.ORDER_TYPE") }}</dt>
          <dd class="col-sm-8" v-if="cafeteria">
            {{ $t("CAFETERIAS.ORDER_TYPE_" + cafeteria.order_type) }}
          </dd>
        </dl>

        <dl class="row" v-if="cafeteria.order_type === 'COUNTER' && cafeteria.service_options && cafeteria.service_options.length">
          <dt class="col-sm-4">{{ $t("CAFETERIAS.SERVICE_OPTIONS") }}</dt>
          <dd class="col-sm-8">
            <ul class="list-unstyled">
              <li v-for="(option, index) in cafeteria.service_options" :key="index">
                {{ $t("CAFETERIAS.SERVICE_OPTION_" + option) }}
              </li>
            </ul>
          </dd>
        </dl>

        <dl class="row" v-if="cafeteria.service_option_other">
          <dt class="col-sm-4">{{ $t("CAFETERIAS.SERVICE_OPTION_OTHER_DETAIL") }}</dt>
          <dd class="col-sm-8" style="white-space: pre-line">
            {{ cafeteria.service_option_other }}
          </dd>
        </dl>

        <dl class="row" v-if="cafeteria?.productionCafeteria">
          <dt class="col-sm-4">
            {{ $t("CAFETERIAS.RELATED_PRODUCTION_CAFETERIA") }}
          </dt>
          <dd class="col-sm-8">
            <cafeteria :cafeteria="cafeteria.productionCafeteria" />
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.HAS_FOLDER") }}</dt>
          <dd class="col-sm-8">
            <icon-check :checked="!!cafeteria.has_folder" />
          </dd>
        </dl>
        <dl
          class="row"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ESTABLISHMENTS)"
        >
          <dt class="col-sm-4">{{ $t("COMMON.ESTABLISHMENT") }}</dt>
          <dd class="col-sm-8">
            <establishment :establishment="cafeteria.establishment" />
          </dd>
        </dl>

        <dl
          class="row"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_SERVICECENTERS)"
        >
          <dt class="col-sm-4">{{ $t("COMMON.SERVICECENTER") }}</dt>
          <dd class="col-sm-8">
            <service-center :serviceCenter="cafeteria.serviceCenter" />
          </dd>
        </dl>

        <dl
          class="row"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
        >
          <dt class="col-sm-4">{{ $t("COMMON.ORGANIZATION") }}</dt>
          <dd class="col-sm-8">
            <organization :organization="cafeteria.organization" />
          </dd>
        </dl>

        <dl class="row" v-if="cafeteria.excerpt">
          <dt class="col-sm-4">{{ $t("CAFETERIAS.NOTE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="cafeteria.excerpt"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $timeZoneDateFormat(cafeteria.created_at) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $timeZoneDateFormat(cafeteria.updated_at) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import Establishment from "@/components/Establishment.vue";
import ServiceCenter from "@/components/ServiceCenter.vue";
import Cafeteria from "@/components/Cafeteria.vue";
import IconCheck from "@/components/IconCheck.vue";

export default {
  name: "cafeteria-view-global",
  components: { Establishment, ServiceCenter, IconCheck, Cafeteria },
  props: ["cafeteria"],

  data() {
    return {};
  },

  created() {},

  methods: {
    cafeteriaUpdated() {
      this.$emit("cafeteriaUpdated", true);
    },
  },

  mounted() {},

  watch: {
    cafeteria(cafeteria) {},
  },
};
</script>
